import {
  Component, ViewEncapsulation, AfterViewInit, Input, OnChanges, OnDestroy, SimpleChanges, ViewChild, ElementRef, OnInit
} from '@angular/core';
import { CatalogProgressTextInputModel } from './catalog-progress-text-input.model';
import { GetCatalogProgressListService } from './api-services/get-catalog-progress-list.service';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

/**
 * 企画進捗管理テキストインプットクラス
 *
 * @export CatalogProgressTextInputComponent
 * @class CatalogProgressTextInputComponent
 */
@Component({
  selector: 'app-catalog-progress-text-input',
  templateUrl: 'catalog-progress-text-input.component.html',
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CatalogProgressTextInputComponent,
      multi: true
    },

  ]
})
export class CatalogProgressTextInputComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit, ControlValueAccessor {
  public selectedOrderCode: string = null;                                      // 受注コード
  public selectedCatalogID: string = null;                                      // 企画回
  public selectedCatalogName: string = null;                                    // 企画回名称
  public selectedEndOrderCode: string = null;                                   // 受付終了受注コード
  public catalogProgressTextInputModel: CatalogProgressTextInputModel = new CatalogProgressTextInputModel();
  public functionAfterSuccessResponse: Function = null;
  @Input() public subid: string = null;
  @Input() public EndOrderCodeField: any;                                       /// 受付終了受注コードフィールド
  @Input() public catalogIDField: any;                                          // 企画回フィールド
  @Input() public progressWorkNumNameField: any;                                // 工程管理NO名フィールド
  @Input() public mediumType: string = null;
  @Input() public initFocusItem: any = null;
  @Input() public text: string = null;

  // レイアウト系の変数
  @Input() public left: number = <number>0;
  @Input() public top: number = <number>0;
  @Input() public width: number | string;
  @Input() public height: number = <number>20;
  @Input() public fontSize: number = <number>9;
  @Input() public editable: boolean = <boolean>true;
  @Input() public tabindex: number = <number>-1;
  @Input() public tabEnabled: boolean = <boolean>true;
  @Input() public forcedEnabledMode: boolean = <boolean>false;
  @Input() public required: boolean = <boolean>false;
  @Input() public maxChars: number = <number>7;
  @Input() public restrict: string = <string>'[0-9]';
  @Input() public autofocus: boolean = <boolean>false;

  /** テキストインプットの参照 */
  @ViewChild('inputText', { static: true }) private inputText: any;

  // ValueAccessor
  public disabled: boolean;
  public onChange(obj: any): void { }
  public onTouched(): void { }
  public writeValue(text: string): void {
    if (text !== this.text) {
      this.setOrderCode(text);
    }
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * Creates an instance of SampleWindowComponent.
   * @param {GetCatalogProgressListService} getCatalogProgressListService 企画進捗管理情報リストを取得する
   * @memberof CatalogProgressTextInputComponent
   */
  constructor(
    private getCatalogProgressListService: GetCatalogProgressListService,
    public elementRef: ElementRef
  ) {
  }

  /**
   * 初期処理
   *
   * @memberof CatalogProgressTextInputComponent
   */
  ngOnInit(): void {
    this.inputText.nativeElement.setAttribute('id', this.subid + '_sub');
    this.inputText.nativeElement.setAttribute('forcedEnabledMode', this.forcedEnabledMode);
  }

  /**
   * コンポーネント終了時
   *
   * @memberof CatalogProgressTextInputComponent
   */
  ngOnDestroy(): void {
    this.selectedOrderCode = null;
    this.selectedCatalogID = null;
    this.selectedCatalogName = null;
    this.catalogIDField = null;
    this.progressWorkNumNameField = null;
    this.selectedEndOrderCode = null;
    this.EndOrderCodeField = null;
  }

  /**
   * ロード完了時
   *
   * @memberof CatalogProgressTextInputComponent
   */
  ngAfterViewInit(): void {
    // テキストインプットインスタンス設定
    this.catalogProgressTextInputModel.catalogProgressTextInputComponent = this;
    // データ取得サービス実行
    this.getCatalogProgressListService.execute(this.catalogProgressTextInputModel, this.mediumType, this.functionAfterSuccessResponse);
  }

  /**
   * 値変更時イベント
   *
   * @param {SimpleChanges} changes 変更イベント
   * @memberof OrderCodeTextInputComponent
   */
  public ngOnChanges(changes: SimpleChanges): void {
    Object.keys(changes).forEach((propName) => {
      switch (propName) {
        case 'text':
          this.text = changes.text.currentValue;

          if (this.catalogProgressTextInputModel.completeUpdateList) {
            // 変更イベント処理実行
            this.changeOrderCodeHandler();
          }
          break;
      }
    });
  }

  /**
   * 受注コード有効有無を返却する
   *
   * @return Boolean:True有効、False無効
   */
  public isValidOrderCode(): boolean {
    if (this.selectedCatalogID.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  /**
   * 受注コードを設定する
   *
   * @param orderCode:受注コード
   */
  public setOrderCode(orderCode: string): void {
    this.text = orderCode;
    if (this.initFocusItem) {
      const queryedElement = document.getElementById(this.initFocusItem).querySelector('textarea, input, select');
      (queryedElement ? <HTMLElement>queryedElement : document.getElementById(this.initFocusItem)).focus();
      this.initFocusItem = null;
    }
  }

  /**
   * 受注コード変更時の処理を行う。
   */
  public changeOrderCodeHandler(): void {
    if (this.catalogIDField != null) {
      if (this.catalogIDField.constructor === HTMLLabelElement) {
        this.catalogIDField.innerText = '';
      } else if (this.catalogIDField.constructor === HTMLInputElement) {
        this.catalogIDField.value = '';
      } else if (this.catalogIDField.constructor === HTMLTextAreaElement) {
        this.catalogIDField.value = '';
      }
    }
    if (this.progressWorkNumNameField != null) {
      if (this.progressWorkNumNameField.constructor === HTMLLabelElement) {
        this.progressWorkNumNameField.innerText = '';
      } else if (this.progressWorkNumNameField.constructor === HTMLInputElement) {
        this.progressWorkNumNameField.value = '';
      } else if (this.progressWorkNumNameField.constructor === HTMLTextAreaElement) {
        this.progressWorkNumNameField.value = '';
      }
    }

    if (this.EndOrderCodeField != null) {
      if (this.EndOrderCodeField.constructor === HTMLLabelElement) {
        this.EndOrderCodeField.innerText = '';
      } else if (this.EndOrderCodeField.constructor === HTMLInputElement) {
        this.EndOrderCodeField.value = '';
      } else if (this.EndOrderCodeField.constructor === HTMLTextAreaElement) {
        this.EndOrderCodeField.value = '';
      }
    }

    this.selectedOrderCode = '';
    this.selectedCatalogID = '';
    this.selectedCatalogName = '';

    this.selectedEndOrderCode = '';

    for (let i = Number(0); i < this.catalogProgressTextInputModel.catalogProgressList.length; i++) {
      if (this.catalogProgressTextInputModel.catalogProgressList[i].OrderCode === this.text) {
        this.selectedOrderCode = this.catalogProgressTextInputModel.catalogProgressList[i].OrderCode;
        this.selectedCatalogID = this.catalogProgressTextInputModel.catalogProgressList[i].CatalogID;
        this.selectedCatalogName = null;
        // catalogIDFieldが設定されてない場合は処理を中断する
        if (this.catalogIDField != null) {
          if (this.catalogIDField.constructor === HTMLLabelElement) {
            this.catalogIDField.innerText = this.catalogProgressTextInputModel.catalogProgressList[i].CatalogID;
          } else if (this.catalogIDField.constructor === HTMLInputElement) {
            this.catalogIDField.value = this.catalogProgressTextInputModel.catalogProgressList[i].CatalogID;
          } else if (this.catalogIDField.constructor === HTMLTextAreaElement) {
            this.catalogIDField.value = this.catalogProgressTextInputModel.catalogProgressList[i].CatalogID;
          }
          this.setFocus();
        }
        if (this.progressWorkNumNameField != null) {
          if (this.progressWorkNumNameField.constructor === HTMLLabelElement) {
            this.progressWorkNumNameField.innerText = this.catalogProgressTextInputModel.catalogProgressList[i].ProgressWorkNumName;
          } else if (this.progressWorkNumNameField.constructor === HTMLInputElement) {
            this.progressWorkNumNameField.value = this.catalogProgressTextInputModel.catalogProgressList[i].ProgressWorkNumName;
          } else if (this.progressWorkNumNameField.constructor === HTMLTextAreaElement) {
            this.progressWorkNumNameField.value = this.catalogProgressTextInputModel.catalogProgressList[i].ProgressWorkNumName;
          }
          this.setFocus();
        }

        if (this.EndOrderCodeField != null) {
          if (this.EndOrderCodeField.constructor === HTMLLabelElement) {
            this.EndOrderCodeField.innerText = this.catalogProgressTextInputModel.catalogProgressList[i].EndOrderCodeField;
          } else if (this.progressWorkNumNameField.constructor === HTMLInputElement) {
            this.EndOrderCodeField.value = this.catalogProgressTextInputModel.catalogProgressList[i].EndOrderCodeField;
          } else if (this.EndOrderCodeField.constructor === HTMLTextAreaElement) {
            this.EndOrderCodeField.value = this.catalogProgressTextInputModel.catalogProgressList[i].EndOrderCodeField;
          }
          this.setFocus();
        }

        return;
      }
    }
    if (this.initFocusItem) {
      const queryedElement = document.getElementById(this.initFocusItem).querySelector('textarea, input, select');
      (queryedElement ? <HTMLElement>queryedElement : document.getElementById(this.initFocusItem)).focus();
      this.initFocusItem = null;
    }
  }

  /**
   * setFocusOverride※テキスト選択解除の為
   */
  public setFocus() {
    this.inputText.nativeElement.focus();
  }

}
